<template>
    <div class="bg-white rounded box-shadow p-3">
        <b-modal hide-footer id="child-ep-add-to-group-modal" size="lg"
                 title="Create EP ID">
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="show">
                        <span :key="index" v-for="(err, index) in validation_errors">
                          {{ err[0] }} <br/>
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-content bg-white rounded box-shadow">

                <div class="form-row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <label class="col-form-label col-form-label-sm" for="ep_id">EP ID <span class="c-required">*</span></label>
                        <input type="text" v-model="child_ep.ep_id" v-validate="'required|numeric'" id="ep_id" name="ep_id" placeholder="EP ID" class="form-control form-control-sm"/>
                        <div class="invalid-feedback">EP ID is required and with numeric number</div>
                    </div>
                </div>
                <div class="form-row mt-3 mb-3">
                    <div class="float-right">
                        <b-button class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Submit</b-button>
                        <b-button class="form-control-sm" size="sm" variant="danger" @click="$bvModal.hide('child-ep-add-to-group-modal')">Cancel</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import http from "@state/http";

    export default {
        name: "childEpAddToGroupModal",
        props: ["child_ep"],
        data() {
            return {
                errorMessage: "",
                status: 0,
                message: "",
                validation_errors: {},
                show: false,
            };
        },

        mounted() {},
        methods: {
            save() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/ses/power/child/group/add", this.child_ep)
                            .then(response => {
                                if(response.data.error === true){
                                    this.validation_errors = response.data.errors;
                                    this.show = true;
                                    this.hide();
                                }else{
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.$bvModal.hide("child-ep-add-to-group-modal");
                                    this.$emit("getParentGroupList");
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },
        },
    };
</script>
